// Plays once when an added journal row first appears: it opens up and fades in.
// `overflow: clip` rather than `hidden`, so sticky cells inside keep sticking while it plays.
export default {
	mounted(element, { value }) {
		if (!value || typeof element.animate !== 'function') return;
		if (window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) return;
		const height = element.offsetHeight;
		element.animate(
			[
				{ height: '0px', opacity: 0, overflow: 'clip' },
				{ height: `${height}px`, opacity: 1, overflow: 'clip' },
			],
			{ duration: 320, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' },
		);
	},
};
